"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mappedCountriesWithStates = exports.countriesWithStates = void 0;
exports.countriesWithStates = ['US', 'CA', 'BR'];
exports.mappedCountriesWithStates = exports.countriesWithStates.map(country => `countryCode:${country}`);
